module.exports = __webpack_public_path__ + "img/exterior-green.1f0239fe.png";